import * as R from 'ramda';

import Handsontable from 'handsontable';

export function getPhysicalRowsIndexes(ht: Handsontable): number[] {
  const countRows = ht.countRows();
  return R.range(0, countRows).map(indexRow => ht.toPhysicalRow(indexRow));
}
